import { createSelector } from 'reselect';

// selectors
const getChipFeed = (state) => state.chipFeed;
const getLoading = (state) => state.loading?.isLoading;
const getLanguage = (state) => state.config?.language;
const getDeviceInteraction = (state) => {
    return state.config?.deviceInteraction;
};
const getAbsConfig = (state) => state?.config?.absConfig;

// reselect function
export const getChipFeedState = createSelector(
    [getChipFeed, getLoading, getLanguage, getDeviceInteraction, getAbsConfig],
    (chipFeed, isLoading, language, deviceInteraction, absConfig) => (
        {
            ...chipFeed,
            isLoading,
            language,
            deviceInteraction,
            showAbsPitch: absConfig?.pitch !== false
        }
    )
);
